exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table td[data-v-26e83d00] {\n  padding: 0.5rem;\n}", ""]);

// exports
